import React, { useState, useRef, useEffect } from 'react';
import { useLanguageCurrency } from '../context/LanguageCurrencyContext';
import i18n from '../i18n/config';

const LanguageSelector = () => {
  const { language, setLanguage } = useLanguageCurrency();
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  const languageRef = useRef(null);

  const languages = [
    { code: 'ar', name: 'العربية', flag: '🇪🇬' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (languageRef.current && !languageRef.current.contains(event.target)) {
        setIsLanguageOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const currentLanguage = languages.find(lang => lang.code === language) || languages[0];

  return (
    <div className="relative" ref={languageRef} style={{ width: '100%', zIndex: 10004 }}>
      <button
        onClick={() => setIsLanguageOpen(!isLanguageOpen)}
        className="flex items-center justify-center gap-1.5 px-2.5 py-1.5 rounded-lg transition-all duration-200 hover:bg-slate-700/50 w-full"
        style={{
          backgroundColor: isLanguageOpen ? 'rgba(213, 181, 119, 0.2)' : 'transparent',
          border: '1px solid rgba(213, 181, 119, 0.2)',
          color: 'rgba(255, 255, 255, 0.9)',
          fontSize: '0.7rem',
        }}
        onMouseEnter={(e) => {
          if (!isLanguageOpen) {
            e.target.style.backgroundColor = 'rgba(213, 181, 119, 0.1)';
          }
        }}
        onMouseLeave={(e) => {
          if (!isLanguageOpen) {
            e.target.style.backgroundColor = 'transparent';
          }
        }}
      >
        <span className="text-sm">{currentLanguage.flag}</span>
        <span className="hidden sm:inline text-xs font-medium">
          {currentLanguage.name}
        </span>
        <svg
          className={`w-3 h-3 transition-transform duration-200 flex-shrink-0 ${isLanguageOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          style={{ color: 'rgba(255, 255, 255, 0.9)' }}
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isLanguageOpen && (
        <div
          className="absolute top-full mt-1 left-0 right-0 min-w-[140px] sm:min-w-[160px] rounded-lg shadow-2xl border"
          style={{
            backgroundColor: 'rgba(29, 42, 59, 0.98)',
            borderColor: 'rgba(213, 181, 119, 0.3)',
            backdropFilter: 'blur(10px)',
            zIndex: 10004,
          }}
        >
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => {
                setLanguage(lang.code);
                i18n.changeLanguage(lang.code);
                setIsLanguageOpen(false);
              }}
              className={`w-full text-left px-3 sm:px-4 py-2.5 sm:py-3 text-sm transition-colors flex items-center gap-2 sm:gap-3 first:rounded-t-lg last:rounded-b-lg ${
                language === lang.code
                  ? 'text-[#D5B577]'
                  : 'text-gray-300 hover:text-white'
              }`}
              style={{
                backgroundColor: language === lang.code ? 'rgba(213, 181, 119, 0.1)' : 'transparent',
              }}
              onMouseEnter={(e) => {
                if (language !== lang.code) {
                  e.target.style.backgroundColor = 'rgba(213, 181, 119, 0.05)';
                }
              }}
              onMouseLeave={(e) => {
                if (language !== lang.code) {
                  e.target.style.backgroundColor = 'transparent';
                }
              }}
            >
              <span className="text-base sm:text-lg">{lang.flag}</span>
              <span className="font-medium">{lang.name}</span>
              {language === lang.code && (
                <svg
                  className="w-4 h-4 ml-auto"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
